module.exports = __webpack_public_path__ + "img/img_31@2x.67f2f4fa.png";